import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2C4.34315 2 3 3.35919 3 5.03583V15.9283C3 17.0782 3.64201 18.1294 4.65836 18.6437L10.6584 21.6795C11.5029 22.1068 12.4971 22.1068 13.3416 21.6795L19.3416 18.6437C20.358 18.1294 21 17.0782 21 15.9283V5.03583C21 3.35919 19.6569 2 18 2H6ZM5 5.03583C5 4.47695 5.44772 4.02389 6 4.02389H18C18.5523 4.02389 19 4.47695 19 5.03583V15.9283C19 16.3116 18.786 16.662 18.4472 16.8334L12.4472 19.8693C12.1657 20.0117 11.8343 20.0117 11.5528 19.8693L5.55279 16.8334C5.214 16.662 5 16.3116 5 15.9283V5.03583ZM15.308 9.67982C15.6334 9.22824 15.5355 8.59523 15.0892 8.26595C14.643 7.93668 14.0174 8.03582 13.692 8.4874L11.5506 11.4592L10.7841 10.4794C10.4413 10.0412 9.81235 9.96719 9.37934 10.3141C8.94632 10.661 8.87319 11.2974 9.21599 11.7356L10.7993 13.7595C10.9933 14.0075 11.2907 14.1494 11.6032 14.1431C11.9156 14.1369 12.2072 13.9831 12.3914 13.7276L15.308 9.67982Z"
      fill={fill}
    />
  </g>
);

export default Icon;
